import { render, staticRenderFns } from "./SmtpProviderList.vue?vue&type=template&id=3896703f&scoped=true&lang=pug&"
import script from "./SmtpProviderList.vue?vue&type=script&lang=js&"
export * from "./SmtpProviderList.vue?vue&type=script&lang=js&"
import style0 from "./SmtpProviderList.vue?vue&type=style&index=0&id=3896703f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896703f",
  null
  
)

export default component.exports